const _menuBtn = $('#js-hamburger')
const _header = $('#js-header')
const _navigation = $('#js-navigation')
const _navigationList = $('.l-navigation__sp')

//ハンバーガーボタンを押したらナビ開閉
_menuBtn.click(function(){
	$('html').toggleClass('is-fixed')
	_menuBtn.toggleClass('is-open')
	_navigation.toggleClass('is-show')
	_navigationList.toggleClass('is-show')
	_header.toggleClass('is-fixed')
})

//sp時のnavメニューを押した時の挙動(ページ内アンカー)
$('.l-navigation__sp .js-menu').click(function(){
	$('html').toggleClass('is-fixed')
	_header.toggleClass('is-fixed')
	_navigationList.removeClass('is-show')
	$('#js-navigation').removeClass('is-show')
	$('#js-hamburger').removeClass('is-open')
})
